import { call, put, select } from 'redux-saga/effects';

import { Stage } from 'system/Stages/types';
import { saveStage } from 'system/Stages/sagas';
import { storeUserProfile } from 'system/Profile/sagas';
import { navigateAfterSubmit, navigateToErrorLayout } from 'system/Routing/sagas';
import { makeSelectVerificationDateByStageStart } from 'system/Analytics/selectors';

import { makeErrorMessage } from 'utils/error';

import { successSubmitAddress, failedSubmitAddress } from '../actions';

import {
  makeSelectAllStageData,
  makeSelectAllStageMetaData,
} from '../selectors/submit';

export function* watchForSubmit() {
  try {
    const stageData = yield select(makeSelectAllStageData());
    const fieldsInputSource = yield select(makeSelectAllStageMetaData());
    const verificationDateStart = yield select(makeSelectVerificationDateByStageStart(Stage.ADDRESS));

    const response = yield call(saveStage, {
      stageId: Stage.ADDRESS,
      stageData,
      metaData: {
        fieldsInputSource,
        verificationDateStart,
        verificationDateEnd: Date.now()
      },
    });

    const { userDossier, error } = response;

    if (error) {
      yield call(navigateToErrorLayout);
    }

    if (userDossier) {
      const { stages } = userDossier;
      yield call(storeUserProfile, userDossier);
      yield call(navigateAfterSubmit, stages, { refetchUserProfile: false });
      yield put(successSubmitAddress());
    }

  } catch (err) {
    yield put(failedSubmitAddress([makeErrorMessage(err)]));

    yield call(navigateToErrorLayout);
  }
}
